import { render } from "./Gift.vue?vue&type=template&id=0c79ff48"
import script from "./Gift.vue?vue&type=script&lang=js"
export * from "./Gift.vue?vue&type=script&lang=js"

import exportComponent from "/data01/virt24076/domeenid/www.rallyestonia.ee/htdocs/ui/template/rallyestonia/moduleTmpl/shop/VueBasket/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__